import '../scss/app.scss';
import 'bootstrap';
import 'jquery';
global.$ = global.jQuery = jQuery;

const loadedComponents = [];

document.addEventListener( 'DOMContentLoaded', async () => {
    /**
     * Bootstrap the components
     */
    for ( const dataComponent of document.querySelectorAll( '[data-component]' ) ) {
        let componentName = dataComponent.dataset.component;

        if(componentName === 'contenteditor::onSave') {
            continue;
        }

        if ( loadedComponents.indexOf( componentName ) === - 1 ) {
            loadedComponents.push( componentName );

            try {
                let component = await import(
                    /* WebpackMode: "lazy" */
                    /* webpackPrefetch: true */
                    /* webpackPreload: true */
                    `./${componentName}.js`
                    );

                component.default();
            } catch ( error ) {
                console.error( 'Loading error: ', error );
            }
        }
    }
} );
